export enum PulseHAStatus {
    ACTIVE = 'Active',
    PASSIVE = 'Passive',
    SUSPICIOUS = 'Suspicious',
    LEAVING = 'Leaving',
    UNAVAILABLE = 'Unavailable'
}
